<mat-toolbar mat-dialog-actions color="primary">
  <div>
    <div class="title">
      Datos de Compra
    </div>
  </div>
<!--  <span class="toolbar-space"></span>-->
  <span class="fx-spacer"></span>
  <button mat-icon-button [mat-dialog-close] tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class="page" [formGroup]="construirFormGroup()" >
  <div fxLayout="column">
    <div fxLayout="column" fxFlex="95">
      <h4>Nombre(s)</h4>
      <mat-form-field appearance="outline">
        <input matInput formControlName="nombre" type="text"  readonly>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex="95">
      <h4>Apellido(s)</h4>
      <mat-form-field appearance="outline">
        <input matInput formControlName="apellido" type="text"  readonly>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex="95">
      <h4>Nro Documento</h4>
      <mat-form-field appearance="outline">
        <input matInput formControlName="documento_nro" type="text"  readonly>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex="95">
      <h4>Celular</h4>
      <mat-form-field appearance="outline">
        <input matInput formControlName="celular_nro" type="text"  readonly>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxFlex="95">
      <h4>Correo</h4>
      <mat-form-field appearance="outline">
        <input matInput formControlName="email" type="text"  readonly>
      </mat-form-field>
    </div>

  </div>

  <br>

  <div fxLayout="row" fxLayoutAlign="center center">
    <div mat-dialog-actions>
      <button mat-raised-button [mat-dialog-close] color="primary">
        Cerrar
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

</div>

